import {
  Box,
  InputAdornment,
  SxProps,
  TextField,
  Theme,
  useMediaQuery,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef } from "react";
import { CustomerDetailsNotesStyles } from "./CustomerDetailsNotesStyles";
import Chat from "../../common/Chat/Chat";
import CustomButton from "../../common/CustomButton/CustomButton";
import { SAVE, ADD_NOTES } from "../../constants";
import saveIcon from "../../assets/svgs/save-icon.svg";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { DeleteNotes, GetNotes, PutEditNotes } from "../Notes/NotesActions";
import { getCookie } from "../../utils/Utility";
import { RootState } from "../../store/store";
import { useParams } from "react-router-dom";

interface UserDetailsProps {
  personLogo: string;
  clientName: string;
  dateAndTime: string;

  userMessage: boolean;
}

export interface PersonChatProps {
  message: string;
  userDetails: UserDetailsProps;
}

interface CustomerDetailsNotesProps {
  personChatArray: PersonChatProps[];
  additionalChatContainer?: SxProps<Theme>;
  additionalSeparatorClass?: SxProps<Theme>;
}

const CustomerDetailsNotes: React.FC<CustomerDetailsNotesProps> = ({
  personChatArray,
  additionalChatContainer,
  additionalSeparatorClass,
}) => {
  const { customerId } = useParams();

  const {
    getNotesResponse,
    addNotesResponse,
    editNotesResponse,
    deleteNotesResponse,
  } = useAppSelector((state: RootState) => state.agentAddNotes);

  const providerId = getCookie("id");
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(
      GetNotes({
        providerId: providerId,
        customerId: customerId,
      })
    );
  }, [dispatch, addNotesResponse, editNotesResponse, deleteNotesResponse]);

  const handleSave = async (
    id: string,
    updatedNote: string,
    providerId: string | number,
    customerId: any
  ) => {
    const requestBody = {
      id: id,
      customerId: customerId,
      providerId: providerId,
      note: updatedNote,
    };

    dispatch(PutEditNotes(requestBody));
  };
  const handleDelete = async (id: string) => {
    dispatch(DeleteNotes(id));
  };
  const isMobile = useMediaQuery("(max-width:1023px)");
  const textFieldRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (textFieldRef.current) {
      setTimeout(() => {
        textFieldRef.current?.focus();
      }, 300);
    }
  }, []);

  return (
    <Box 
      id="customer-details-notes-container"
      data-test-id="test-customer-details-notes-container"
      aria-label="Customer details notes container"
      sx={CustomerDetailsNotesStyles.container}
    >
      {!getNotesResponse ? (
        <Box 
          id="customer-details-notes-no-data"
          data-test-id="test-customer-details-notes-no-data"
          aria-label="No notes available message"
          sx={CustomerDetailsNotesStyles.noDataScreen}
        >
          <Typography 
            id="customer-details-notes-no-data-text"
            data-test-id="test-customer-details-notes-no-data-text"
            aria-label="No notes available text"
            variant="h6" 
            color="textSecondary"
          >
            No Notes Available for this Customer
          </Typography>
        </Box>
      ) : (
        <>
          <Box
            id="customer-details-notes-chat-container"
            data-test-id="test-customer-details-notes-chat-container"
            aria-label="Customer notes chat container"
            sx={Object.assign(
              {},
              CustomerDetailsNotesStyles.chatContainer,
              additionalChatContainer,              
            )}
          >
            {getNotesResponse?.map((personChat, index) => {
              return (
                <Chat
                  key={personChat.id || index}
                  personChat={personChat}
                  index={index}
                  onSave={handleSave}
                  onDelete={handleDelete}
                />
              );
            })}
          </Box>

          {/* <Box>
            <TextField
              id="customer-details-notes-input"
              data-test-id="test-customer-details-notes-input"
              aria-label="Add notes input field"
              inputRef={textFieldRef}
              sx={CustomerDetailsNotesStyles.textField}
              placeholder={ADD_NOTES}
              multiline
              maxRows={3}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="end">
                    <Box 
                      id="customer-details-notes-save-button-container"
                      data-test-id="test-customer-details-notes-save-button-container"
                      aria-label="Save notes button container"
                      sx={CustomerDetailsNotesStyles.customButton}
                    >
                      {!isMobile ? (
                        <CustomButton
                          id="customer-details-notes-save-button"
                          data-test-id="test-customer-details-notes-save-button"
                          aria-label="Save notes button"
                          additionalClassName={
                            CustomerDetailsNotesStyles.saveButton
                          }
                          text={SAVE}
                        />
                      ) : (
                        <img 
                          id="customer-details-notes-save-icon"
                          data-test-id="test-customer-details-notes-save-icon"
                          aria-label="Save notes icon"
                          src={saveIcon} 
                          alt={SAVE} 
                        />
                      )}
                    </Box>
                  </InputAdornment>
                ),
              }}
              inputProps={{
                style: {
                  overflow: "auto",
                },
              }}
              autoFocus
            />
          </Box> */}
          <Box
            id="customer-details-notes-separator"
            data-test-id="test-customer-details-notes-separator"
            aria-label="Notes separator"
            sx={Object.assign(
              {},
              CustomerDetailsNotesStyles.separator,
              additionalSeparatorClass
            )}
          ></Box>
        </>
      )}
    </Box>
  );
};

export default CustomerDetailsNotes;
